export function formatCurrency (number) {
    return parseFloat(number).toLocaleString('es-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
};